import { Service } from '@angular/core';
import { MadCloudCommit } from '@common/git/models/mad-cloud-commit.model';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';

@CollectionStateSelectors({
  stateType: CommitsState
})
@State<CommitsState>({
  name: CommitsState.source
})
@Service({ autoProvided: false })
export class CommitsState extends CollectionStateBase {
  static override source = 'Commits';
  getSource(): string {
    return CommitsState.source;
  }

}

@Service()
export class CommitsDataService extends CollectionDataServiceBase<MadCloudCommit> {
  protected readonly stateType = CommitsState;
}
